'use strict'
const ECPN_ORGANIZATION_ID = 'ECPN'

/**
 * @param {*} user Auth0 user info from JWT
 * @return {Boolean} true if and only if the user is a member of the organization ECPN.
 */
const userIsEcpn = user => {
  return !!(user && user.identity_data && user.identity_data.organizations
    && user.identity_data.organizations.filter(org => {return org === ECPN_ORGANIZATION_ID}).length > 0
  )
}

module.exports = {
  ECPN_ORGANIZATION_ID,
  userIsEcpn
}
